import { useRef, useContext, useEffect } from 'react';

import { GlobalContext } from "../contexts/globalContext";
import { ProjectDetailsContext } from "../contexts/projectDetailsContext";
import { AddConferenceProvider } from "../contexts/addConferenceContext"

import styles from './ProjectDetailsComponent.module.css'

import AddGuestComponent from './popup/addParticipantsParts/AddGuestsComponent';
import AddTopicsComponent from './popup/AddTopicsComponent';
import AddFilesComponent from './popup/AddFilesComponent';
import AddPartipicantsComponent from './popup/addParticipantsParts/AddParticipantsComponent';
import ConferenceListComponent from './projectDetails/conferences/PD_ConferenceListComponent';
import ParticipantListComponent from './projectDetails/participants/PD_ParticipantListComponent';
import FileListComponent from './projectDetails/files/PD_FileListComponent';
import TopicListComponent from './projectDetails/topics/PD_TopicListComponent';
import AddMembersComponent from './popup/addParticipantsParts/AddMembersComponent';
import AddPartnersComponent from './popup/addParticipantsParts/AddPartnersComponent';
import AddVisitorsComponent from './popup/addParticipantsParts/AddVisitorsComponent';
import HeaderComponent from './commons/HeaderComponent';
import NotificationComponent from './NotificationComponent';
import ConferenceDetailsComponent from './popup/conferenceDetails/ConferenceDetailsComponent';
import DeleteNotificationComponent from './popup/common/DeleteNotificationComponent';
import NewConferenceAddComponent from './popup/NewConferenceAddComponent';
import NewPresentationComponentPopup from './popup/NewPresentationComponentPopup';
import NewMeetingAddComponent from './popup/NewMeetingAddComponent';

import video from '../graphics/big wave fundal loop_6.mp4'


const ProjectDetailsComponent = () => {

    const ref = useRef()

    const { addGuest, setSelectedParentForFiles, selectedProject, appHeight, appWidth, setOpenNotif, openNotif, seeNotification, setSeeNotification } = useContext(GlobalContext);
    const {
        addTopic,
        addFiles,
        addParticipants,
        createConference,
        editConference,
        editTopic,
        addMembers,
        addVisistors,
        addPartners,
        createMeeting,
        deleteClicked, setDeleteClicked,
        createPresentation
    } = useContext(ProjectDetailsContext);

    useEffect(() => {
        if (selectedProject.topics && selectedProject.topics.length > 0) {
            setSelectedParentForFiles(selectedProject.topics[0])
        }
    }, [])

    useEffect(() => {
        if(!seeNotification){
            setTimeout(() => {
                setOpenNotif(false)
            }, 450);
            
        } else{
            setOpenNotif(true)
        }
    }, [seeNotification])   

    return (
        <div ref={ref} className={styles.project_component} style={{ height: `${appHeight}px`, width: `${appWidth}px`}}>
            <video id="background-video" autoPlay loop playsInline muted style={{ height: `${appHeight}px`, width: `${appWidth}px`}}>
                <source src={video} type="video/mp4"/>
            </video>

            <div className={styles.topShadow} />

            <HeaderComponent setSeeNotification={setSeeNotification} seeNotification={seeNotification} />

            {openNotif && <NotificationComponent />}

            <div className={styles.lists}>
                <ConferenceListComponent />
                <ParticipantListComponent />
                <TopicListComponent />
                <FileListComponent />
            </div>

            <div className={styles.bottomShadow} />
            
            {deleteClicked?.shown === true && <DeleteNotificationComponent deleteClicked={deleteClicked} setDeleteClicked={setDeleteClicked} />}

            {addTopic && <AddTopicsComponent />}
            {addFiles && <AddFilesComponent />}
            {addParticipants && <AddPartipicantsComponent />}
            {editTopic && <AddTopicsComponent />}
            
            {addGuest && <AddGuestComponent />}
            {addMembers && <AddMembersComponent />}
            {addPartners && <AddPartnersComponent />}
            {addVisistors && <AddVisitorsComponent />}
            
            {createConference && <AddConferenceProvider><NewConferenceAddComponent /> </AddConferenceProvider>}
            {createPresentation && <AddConferenceProvider><NewPresentationComponentPopup/></AddConferenceProvider>}

            {createMeeting && <AddConferenceProvider><NewMeetingAddComponent /> </AddConferenceProvider>}

            {editConference && <AddConferenceProvider>
                <ConferenceDetailsComponent />
            </AddConferenceProvider>}
        </div>
    );

}

export default ProjectDetailsComponent;